import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { AppSettingService } from '../app.service';

@Component({
	selector: 'app-begin-career-exploration',
	templateUrl: './begin-career-exploration.component.html',
	standalone: false
})
export class BeginCareerExplorationComponent implements OnInit {
	constructor(
		private router: Router
	) { }

	toggled: boolean = AppSettingService.widgetMobile();
	showMinimize: boolean = AppSettingService.widgetMobile();

	@HostListener('window:resize', ['$event'])
	onResize(event: any): void {
		this.setDisplay();
	}

	private setDisplay(): void {
		this.showMinimize = AppSettingService.widgetMobile();
		this.toggled = !this.showMinimize ? false : this.toggled;
	}

	toggleCollapse(): void {
		this.toggled = !this.toggled;
	}

	exploreCareers(event: any):void {
		this.router.navigateByUrl("/Career/Exploration");		
	}

	ngOnInit(): void {

	}
}
